import styled from 'styled-components';

import { link, outlinePrimaryButton } from '~/App/helpers/mixins';
import mediaHelper from '~/App/helpers/media-helper';
import mq from '~/App/helpers/mq';

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const OutlineButton = styled.button`
  ${outlinePrimaryButton};
  display: block;
  margin: 1rem auto 0;
  background-position-x: calc(1rem);
  background-position-y: center;
  background-repeat: no-repeat;
  background-size: 20px 20px;
  background-image: url(${mediaHelper.getUrl(
    'https://res.cloudinary.com/cancerfonden/image/upload/v1591085364/assets/login/bankid_logo.svg'
  )});

  ${mq('<small')`
    padding: 0.5rem calc(2rem + 20px);
  `}

  ${mq('>mediumLarge')`
    padding: 0.625rem calc(2.5rem + 20px);
    background-position-x: 1.25rem;
  `};
`;

export const LinkButton = styled.button`
  ${link};
  text-decoration: underline;
  margin: 1rem auto 0;
  padding: 0.625rem;
  font-size: 1rem;
  text-align: center;
  border: none;
  background-color: inherit;

  ${mq('<small')`
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    line-height: 0.75rem;
  `};
`;

export const P = styled.p`
  margin-bottom: 1rem;
`;

export const ContactLink = styled.a`
  color: ${({ theme }) => theme.colors.darkBlue};
  text-decoration: none;
  &:visited {
    color: ${({ theme }) => theme.colors.darkBlue};
  }
  &:hover {
    color: ${({ theme }) => theme.colors.hoverBlue};
  }
`;
